module.exports = __webpack_public_path__ + "static/dedicated-support-5650fe4b0d930de151f3e9021f5a0ab8.webp";